

export default {
  state:{
    revision:{
      tokenAtencion: null,
      comentarios: null
    },

    revisiones:{},
  },

  mutations:{
    setRevision(state, newData){
      state.revision = { ...state.revision, ...newData }
    },

    setComentarios(state, newData){
      state.revision.comentarios = { ...state.revision.comentarios, ...newData }
    },


    setRevisiones(state, { tokenAtencion, data }) {
      // Si no existe la clave `tokenAtencion`, inicialízala como un objeto vacío
      if (!state.revisiones[tokenAtencion]) {
        state.revisiones[tokenAtencion] = {};
      }
      // Extiende los datos existentes para ese `tokenAtencion` con los nuevos datos
      state.revisiones[tokenAtencion] = {
        ...state.revisiones[tokenAtencion],
        ...data
      };
    }
  }
}